<template>
  <hm-content class="">
    <el-table :data="mpList" stripe border size="small">
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="小程序名称"
        prop="nickName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="小程序归属"
        prop="principalName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="createTime"
        label="创建时间"
      ></el-table-column>
      <el-table-column
        label="操作"
        width="150"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <el-button size="small" type="text" @click="setDomain(scope.row)"
            >配置服务器域名</el-button
          >
          <el-button size="small" type="text" @click="setExistDomain(scope.row)"
            >一键配置</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="域名配置"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="ruleForm"
        label-width="200px"
        :model="ruleForm"
        :rules="rules"
      >
        <el-form-item label="request合法域名:" prop="requestdomain">
          <div class="flex item-center">
            <el-input
              size="small"
              type="text"
              v-model.trim="ruleForm.requestdomain"
            ></el-input>
            <div class="add-wrapper" @click="addDomain('requestdomainList')">
              <span class="hmicon icon-hao pointer"></span>
            </div>
          </div>
          <div
            class="flex item-center"
            v-for="(v, i) in list.requestdomainList"
            :key="i"
          >
            <el-input size="small" type="text" v-model.trim="v.url"></el-input>
            <div class="minus-wrapper">
              <span
                class="hmicon icon-jianhao pointer"
                @click="deleteTime('requestdomainList', i)"
              ></span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="socket合法域名:" prop="wsrequestdomain">
          <div class="flex item-center">
            <el-input
              size="small"
              type="text"
              v-model.trim="ruleForm.wsrequestdomain"
            ></el-input>
            <div class="add-wrapper" @click="addDomain('wsrequestdomainList')">
              <span class="hmicon icon-hao pointer"></span>
            </div>
          </div>
          <div
            class="flex item-center"
            v-for="(v, i) in list.wsrequestdomainList"
            :key="i"
          >
            <el-input size="small" type="text" v-model.trim="v.url"></el-input>
            <div class="minus-wrapper">
              <span
                class="hmicon icon-jianhao pointer"
                @click="deleteTime('wsrequestdomainList', i)"
              ></span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="uploadFile合法域名:" prop="uploaddomain">
          <div class="flex item-center">
            <el-input
              size="small"
              type="text"
              v-model.trim="ruleForm.uploaddomain"
            ></el-input>
            <div class="add-wrapper" @click="addDomain('uploaddomainList')">
              <span class="hmicon icon-hao pointer"></span>
            </div>
          </div>
          <div
            class="flex item-center"
            v-for="(v, i) in list.uploaddomainList"
            :key="i"
          >
            <el-input size="small" type="text" v-model.trim="v.url"></el-input>
            <div class="minus-wrapper">
              <span
                class="hmicon icon-jianhao pointer"
                @click="deleteTime('uploaddomainList', i)"
              ></span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="downloadFile合法域名:" prop="downloaddomain">
          <div class="flex item-center">
            <el-input
              size="small"
              type="text"
              v-model.trim="ruleForm.downloaddomain"
            ></el-input>
            <div class="add-wrapper" @click="addDomain('downloaddomainList')">
              <span class="hmicon icon-hao pointer"></span>
            </div>
          </div>
          <div
            class="flex item-center"
            v-for="(v, i) in list.downloaddomainList"
            :key="i"
          >
            <el-input size="small" type="text" v-model.trim="v.url"></el-input>
            <div class="minus-wrapper">
              <span
                class="hmicon icon-jianhao pointer"
                @click="deleteTime('downloaddomainList', i)"
              ></span>
            </div>
          </div>
        </el-form-item>
        <div class="flex item-center flex-center">
          <el-button
            type="primary"
            @click="submitRuleForm('ruleForm')"
            size="small"
            >保 存</el-button
          >
          <el-button @click="dialogVisible = false" size="small"
            >取 消</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      openlink: "",
      dialogVisible: false,
      mpList: [],
      currentRow: {},
      action: "get",
      list: {
        requestdomainList: [],
        wsrequestdomainList: [],
        uploaddomainList: [],
        downloaddomainList: []
      },
      ruleForm: {
        requestdomain: "",
        wsrequestdomain: "",
        uploaddomain: "",
        downloaddomain: ""
      },
      rules: {
        requestdomain: {
          required: true,
          message: "请输入request合法域名",
          trigger: "blur"
        },
        wsrequestdomain: {
          required: true,
          message: "请输入socket合法域名",
          trigger: "blur"
        },
        uploaddomain: {
          required: true,
          message: "请输入uploadFile合法域名",
          trigger: "blur"
        },
        downloaddomain: {
          required: true,
          message: "请输入downloaddomain合法域名",
          trigger: "blur"
        }
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryBindMpList();
  },
  mounted() {},
  methods: {
    async setExistDomain(row) {
      let params = {
        authorizerAppid: row.authorizerAppid,
        action: "set",
        requestdomain: [
          "https://hmma.baidu.com",
          "https://hx.hemiao100.com",
          "https://hexin.hemiao100.com",
          "https://imgcdn.hemiao100.com"
        ],
        wsrequestdomain: ["wss://hx.hemiao100.com"],
        uploaddomain: [
          "https://hx.hemiao100.com",
          "https://imgcdn.hemiao100.com"
        ],
        downloaddomain: [
          "https://hx.hemiao100.com",
          "https://img11.360buyimg.com",
          "https://img13.360buyimg.com",
          "https://img14.360buyimg.com",
          "https://imgcdn.hemiao100.com",
          "https://img30.360buyimg.com",
          "https://wx.qlogo.cn",
          "https://thirdwx.qlogo.cn",
          "https://mmbiz.qpic.cn",
          "https://hexin.hemiao100.com"
        ]
      };
      await this.$store.dispatch("mpDomainSetting", params);
      this.queryBindMpList();
    },
    submitRuleForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const {
            requestdomain,
            wsrequestdomain,
            uploaddomain,
            downloaddomain
          } = this.createReqParams();
          this.mpDomainSetting(
            requestdomain,
            wsrequestdomain,
            uploaddomain,
            downloaddomain
          );
        }
      });
    },
    // 生成请求参数
    createReqParams() {
      const requestdomain = [
        this.ruleForm.requestdomain,
        ...this.list.requestdomainList.map(v => v.url)
      ].filter(v => v);
      const wsrequestdomain = [
        this.ruleForm.wsrequestdomain,
        ...this.list.wsrequestdomainList.map(v => v.url)
      ].filter(v => v);
      const uploaddomain = [
        this.ruleForm.uploaddomain,
        ...this.list.uploaddomainList.map(v => v.url)
      ].filter(v => v);
      const downloaddomain = [
        this.ruleForm.downloaddomain,
        ...this.list.downloaddomainList.map(v => v.url)
      ].filter(v => v);
      return {
        requestdomain,
        wsrequestdomain,
        uploaddomain,
        downloaddomain
      };
    },
    addDomain(domainList) {
      this.list[domainList].push({ url: "" });
    },
    deleteTime(domainList, i) {
      this.list[domainList].splice(i, 1);
    },
    setDomain(row) {
      this.currentRow = row;
      this.reset();
      this.queryMpDomainList();
      this.dialogVisible = true;
    },
    reset() {
      for (let key in this.ruleForm) {
        this.ruleForm[key] = "";
      }
      for (let key in this.list) {
        this.list[key] = [];
      }
    },
    async queryBindMpList() {
      const { result } = await this.$store.dispatch("queryBindMpList");
      this.mpList = result;
    },
    async queryMpDomainList() {
      const { result } = await this.$store.dispatch("queryMpDomainList", {
        authorizerAppid: this.currentRow.authorizerAppid,
        action: "get"
      });
      const {
        requestdomain,
        wsrequestdomain,
        uploaddomain,
        downloaddomain
      } = result;
      this.ruleForm.requestdomain = (requestdomain && requestdomain.length)
        ? requestdomain[0]
        : "";
      this.ruleForm.wsrequestdomain =( wsrequestdomain && wsrequestdomain.length)
        ? wsrequestdomain[0]
        : "";
      this.ruleForm.uploaddomain = (uploaddomain && uploaddomain.length) ? uploaddomain[0] : "";
      this.ruleForm.downloaddomain = (downloaddomain && downloaddomain.length)
        ? downloaddomain[0]
        : "";
      if (requestdomain && requestdomain.length > 1) {
        const list = requestdomain.slice(1);
        list.map(v => {
          this.list.requestdomainList.push({
            url: v
          });
        });
      }
      if (wsrequestdomain && wsrequestdomain.length > 1) {
        const list = wsrequestdomain.slice(1);
        list.map(v => {
          this.list.wsrequestdomainList.push({
            url: v
          });
        });
      }
      if (uploaddomain && uploaddomain.length > 1) {
        const list = uploaddomain.slice(1);
        list.map(v => {
          this.list.uploaddomainList.push({
            url: v
          });
        });
      }
      if (downloaddomain && downloaddomain.length > 1) {
        const list = downloaddomain.slice(1);
        list.map(v => {
          this.list.downloaddomainList.push({
            url: v
          });
        });
      }
      this.action = this.ruleForm.requestdomain ? "set" : "add";
    },
    async mpDomainSetting(
      requestdomain,
      wsrequestdomain,
      uploaddomain,
      downloaddomain
    ) {
      let params = {
        authorizerAppid: this.currentRow.authorizerAppid,
        action: "set",
        requestdomain,
        wsrequestdomain,
        uploaddomain,
        downloaddomain
      };
      const { code } = await this.$store.dispatch("mpDomainSetting", params);
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        this.dialogVisible = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.add-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;
  .hmicon {
    font-size: 14px;
  }
}

.minus-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #e50065;
  margin-left: 10px;
  box-sizing: border-box;
  .hmicon {
    color: #e50065;
    font-size: 14px;
  }
}
</style>
